import { JSONSchemaType } from 'ajv'

export interface IStandardConnectorFormData {
  connectorTypeId: string
  connectorName: string
  connectorJson: string
  outputParams: string
  isInactive: boolean
}

const StandardConnectorSchema: JSONSchemaType<IStandardConnectorFormData> = {
  type: 'object',
  properties: {
    connectorTypeId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    connectorName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    connectorJson: {
      type: 'string',
    },
    outputParams: {
      type: 'string',
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['connectorTypeId', 'connectorName'],
  additionalProperties: false,
}

export default StandardConnectorSchema
